var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingRequest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#1d150a"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.4s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#1976d2"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.3s"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#1d150a"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.2s"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#1976d2"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.3s"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#1d150a"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.2s"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#1976d2"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.1s"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#1d150a"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.2s"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#1976d2"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.1s"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#1d150a"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "0s"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingRequest);
export default __webpack_public_path__ + "static/media/pending-request.5b5d66990ea34a0ef7fddfb57139917f.svg";
export { ForwardRef as ReactComponent };